require('./bootstrap');

import {createApp, registerRuntimeCompiler} from "vue";
import mitt from 'mitt';
import VueGtag, {useGtag, useState} from "vue-gtag-next";
import Popper from "vue3-popper";
import LazyLoad from "vanilla-lazyload";
import { Tooltip, Popover, Carousel } from 'bootstrap';
import BaseRegSizeForm from './components/Partials/BaseRegSizeForm.vue';
import RegForm from './components/Partials/RegForm.vue';
import SizeForm from './components/Partials/SizeForm.vue';
import SlimlineRegSizeForm from './components/Partials/SlimlineRegSizeForm.vue';
import SlimlineRegForm from './components/Partials/SlimlineRegForm.vue';
import SlimlineSizeForm from './components/Partials/SizeForm.vue';
import Loading from './components/Partials/Loading.vue';
import CookieBanner from './components/Partials/CookieBanner.vue';
import BuyAgainModal from './components/Modals/BuyAgainModal.vue';
import RatingLabels from './components/Tyres/Badges/RatingLabels.vue';

if (document.getElementById('app')) {
    const emitter = mitt();
    const app = createApp({
        created() {
            let app = document.getElementById('app');
        },
        data() {
            return {
                
            }
        },
        mounted() {
            init_tooltip();
            init_popover();
            this.updateBrandCount();
            this.emitter.on('refreshTooltips', data => {
                this.initTooltip();
            });
        },
        methods: {
            initTooltip: function() {
                init_tooltip()
            },
            initPopover: function() {
                init_popover()
            },
            async updateBrandCount() {
                var brandCountElement = document.getElementById('nav-brand-count');
                var brandCount = brandCountElement.getAttribute('data-nav-brand-count');

                if(brandCount == '') {
                    var response = await axios.get('/ajax/get_brand_count');
                    brandCountElement.innerHTML = response.data[0];
                }
            }
        }
    });

    app.use(VueGtag);

    const {query} = useGtag();

    if(window.document.querySelector("meta[name=advertising_cookies_allowed]")) {
        query('consent', 'default', {
            'ad_storage': 'granted',
            'ad_user_data': 'granted',
            'ad_personalization': 'granted'
        });
    }
    else {
        query('consent', 'default', {
            'ad_storage': 'denied',
            'ad_user_data': 'denied',
            'ad_personalization': 'denied'
        });
    }

    if(window.document.querySelector("meta[name=performance_cookies_allowed]")) {
        query('consent', 'default', {
            'analytics_storage': 'granted',
        });
    }
    else {
        query('consent', 'default', {
            'analytics_storage': 'denied',
        });
    }

    const { property } = useState();

    property.value = [
        {
            id: 'G-6GF7E01QV1',
            params: {
                send_page_view: true
            },
            default: true
        },
        {
            id: 'G-BXNJ4GH8EX',
            params: {
                send_page_view: true
            }
        }
    ];

    app.use(Popper);

    //Intercepting axios requests to prepend baseUrl to all requests, for proxy reasons <(^.^)>
    var baseUrlMeta = document.querySelector('meta[name="base_url"]').content.slice(0, -1);

    app.config.compilerOptions.delimiters = ["@{{", "}}"];
    app.config.globalProperties.emitter = emitter;
    app.config.globalProperties.baseUrl = baseUrlMeta;

    axios.interceptors.request.use(function(config) {
        config.url = baseUrlMeta + config.url;
        return config;
    });

    app.component('BaseRegSizeForm', BaseRegSizeForm)
       .component('RegForm', RegForm)
       .component('SizeForm', SizeForm)
       .component('Loading', Loading)
       .component('CookieBanner', CookieBanner)
       .component('SlimlineRegSizeForm', SlimlineRegSizeForm)
       .component('SlimlineRegForm', SlimlineRegForm)
       .component('SlimlineSizeForm', SlimlineSizeForm)
       .component('BuyAgainModal', BuyAgainModal)
       .component('RatingLabels', RatingLabels);

    app.mount("#app");
} else {
    init_tooltip();
}

function init_tooltip() {
    var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
    var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
        return new Tooltip(tooltipTriggerEl)
    })
}

function init_popover() {
    var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
    var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
        return new Popover(popoverTriggerEl)
    })
}

// https://www.andreaverlicchi.eu/vanilla-lazyload/
var lazyLoadInstance = new LazyLoad();